import { createFileRoute, redirect } from "@tanstack/react-router";

// Merged into /incident-reporting so the two pages stop competing in search. Permanent redirect keeps old links working.
export const Route = createFileRoute("/security-incident-reporting-software")({
  beforeLoad: () => {
    throw redirect({ to: "/incident-reporting", statusCode: 301 });
  },
});
